import { render, staticRenderFns } from "./Euthanasia.vue?vue&type=template&id=2c877d18&scoped=true&"
import script from "./Euthanasia.vue?vue&type=script&lang=js&"
export * from "./Euthanasia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c877d18",
  null
  
)

export default component.exports